import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PerfMetricsComponent} from './perf-metrics.component';
import {AlertBannerModule} from "../../lib/alert-banner";


@NgModule({
  declarations: [PerfMetricsComponent],
  imports: [
    CommonModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [PerfMetricsComponent]
})
export class PerfMetricsModule {
}
